export default [
    {
        path: '/SelectedProject',
        name: 'SelectedProject',
        title: '我的入选项目',
        component: () => import('@/views/SelectedProject/index.vue')
    },
    {
        path: '/SelectedProjectDetail',
        name: 'SelectedProjectDetail',
        title: '入选项目详情',
        component: () => import('@/views/SelectedProject/detail.vue')
    },
    {
        path: '/TaskBook',
        name: 'TaskBook',
        title: '任务书',
        component: () => import('@/views/SelectedProject/TaskBook/index.vue')
    },
    {
        path: '/TaskForm',
        name: 'TaskForm',
        title: '任务书表单',
        component: () => import('@/views/SelectedProject/TaskBook/TaskForm.vue')
    },
    {
        path: '/SummaryReport',
        name: 'SummaryReport',
        title: '总结报告',
        component: () => import('@/views/SelectedProject/SummaryAndFinalReport/index.vue')
    },
    {
        path: '/FinalReport',
        name: 'FinalReport',
        title: '结项报告',
        component: () => import('@/views/SelectedProject/SummaryAndFinalReport/index.vue')
    },
    {
        path: '/SummaryForm',
        name: 'SummaryForm',
        title: '总结报告表单',
        component: () => import('@/views/SelectedProject/SummaryAndFinalReport/SummaryAndFinalForm.vue')
    }
]